import styled from 'styled-components'

const EventHeroStyle = styled.section`
	--firstChildDistance: var(--sp10x);
	--dragPadTB: var(--sp10x);
	--dragPadLR: var(--sp3x);

	.event-hero-item-wrap {
		position: relative;
		margin-top: calc(var(--firstChildDistance) + 1.5%);

		&:not(:first-child) {
			margin-top: var(--sectionDistance);
		}

		.image-cont {
			img {
				transform: scale(1);
				transition: transform var(--trTime) ease-out;
			}

			@media (hover: hover) {
				&:hover {
					img {
						transform: scale(1.3);
					}
				}
			}
		}
	}

	//! Cursor styles
	.event-drag-container {
		position: absolute;
		z-index: 3;
		pointer-events: none;
		transform: scale(0);

		@media (hover: none) {
			display: none;
		}

		.event-drag {
			position: absolute;
			top: 0;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			width: var(--roundButtonCursorSize);
			height: var(--roundButtonCursorSize);
			border-radius: 50%;
			color: var(--bodyColor);
			background-color: var(--primaryColor9);
			transform: translate(-50%, -50%);
			padding: var(--dragPadTB) var(--dragPadLR);
			text-align: center;
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--firstChildDistance: var(--sp8x);
		--dragPadTB: var(--sp5x);
		--dragPadLR: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--firstChildDistance: var(--sp7x);
		--dragPadTB: var(--sp5x);
		--dragPadLR: var(--sp1-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--firstChildDistance: calc(var(--sp11x) / 2);
		--dragPadTB: var(--sp5x);
		--dragPadLR: var(--sp1-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--firstChildDistance: calc(var(--sp21x) / 2);
		--dragPadTB: var(--sp5x);
		--dragPadLR: var(--sp1x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--firstChildDistance: var(--sp8x);
		--dragPadTB: var(--sp5x);
		--dragPadLR: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--firstChildDistance: var(--sp8x);
		--dragPadTB: var(--sp5x);
		--dragPadLR: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--firstChildDistance: var(--sp5x);
		--dragPadTB: var(--sp5x);
		--dragPadLR: var(--sp2x);
	}
`

export default EventHeroStyle
